<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="
                  isDeletePage() != true ? 'Game Logs' : 'Deleted Game Logs'
                "
              ></h3>
              <!-- <template v-if="isDeletePage() != true">
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/inquiry-requests/create"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
              </template> -->
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    color="#e60040"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col sm="2">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    clearable
                    @click:clear="(filter.is_active = null), (page = 1)"
                    label="Status"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="900"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>&nbsp; Sr. No.</th>
                      <th class="text-left">Status</th>
                      <th class="text-left">User Name</th>
                      <th class="text-left">Game Name</th>
                      <th class="text-left" style="min-width: none">
                        Room Name
                      </th>
                      <th class="text-left" style="min-width: none">
                        Coin Used
                      </th>
                      <th class="text-left" style="min-width: none">
                        Coin Earned
                      </th>
                      <!-- <th class="text-left">Status</th>
                      <th class="text-left">Validity</th> -->
                    </tr>
                  </thead>
                  <tbody v-if="game_logs.length != 0">
                    <tr
                      v-for="(game_log, i) in game_logs"
                      :key="`game_log_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': game_logs.length - 1 == i,
                      }"
                    >
                      <td>&nbsp;{{ i + 1 }}</td>
                      <td>
                        <v-tooltip bottom v-if="game_log.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>Gamelog is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="game_log.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Gamelog is InActive</span>
                        </v-tooltip>
                      </td>

                      <td>
                        {{ game_log.user ? game_log.user.first_name : "" }}
                      </td>
                      <td>
                        {{ game_log.game_name || "" }}
                      </td>
                      <td>
                        {{ game_log.room ? game_log.room.name : "" }}
                      </td>
                      <td>
                        {{ game_log.coins_used || "" }}
                      </td>
                      <td>
                        {{ game_log.coins_earned || "" }}
                      </td>
                      <!-- <td>
                        {{
                          game_log.status == 1 ? "COMPLETED" : "PENDING"
                        }}
                      </td>
                      <td>{{ game_log.valid_till || "" }}</td> -->
                      <td class="text-right">
                        <template v-if="isDeletePage() != true">
                          <!-- <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Delete_this(game_log.id)"
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this Gamelog</span>
                          </v-tooltip> -->
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Restore_this(game_log.id)"
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this game_log</span>
                          </v-tooltip>
                        </template>

                        <!-- <v-tooltip bottom> -->
                        <!-- <template v-slot:activator="{ on, attrs }"> -->
                        <!-- <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="ml-2"
                          @click="downloadIdCard(game_log.user.id)"
                          :loading="isCardLoading[game_log.user.id]"
                          fab
                          x-small
                          color="primary"
                          target="_blank"
                        >
                          <v-icon>mdi-card-account-details-outline</v-icon>
                        </v-btn> -->
                        <!-- </template> -->
                        <!-- <span>Download Id Card</span>  -->
                        <!-- </v-tooltip> -->
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="8" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "game_logsPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: "",
        is_type: "",
        is_selected: false,
      },
      isCardLoading: {},
      excel_sample: [],
      game_logs: [],
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      ExportGamelogTypes: [],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      excel_fields: {
        "Sr No": "sr_no",
        Name: "name",
      },
      isLoading: false,

    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.is_type = this.filter.is_type ? this.filter.is_type : "";

      // this.filter.show_deleted = this.$route.query.open_trash ? 1 : 2;
      // this.filter.is_type = this.filter.is_type ? this.filter.is_type : "";
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&is_active=" +
        this.filter.is_active +
        "&is_type=" +
        this.filter.is_type +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`game_logs?${query}`)
        .then((response) => {
          this.game_logs = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
      this.isLoading = false;
    },
    //Generate Excel
    async generateExcel() {
      let query = "search_keyword=" + this.filter.search_keyword;
      let response = await axios.get(`game_log_exports?${query}`);
      console.log(response.data.data);
      if (response) {
        window.open(`${response.data.data}`, "_blank");
      }
    },
    async Delete_this(id) {
      this.delete_game_log = true;
      await axios
        .post(`/game_logs/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.delete_game_log = false;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
    async Restore_this(id) {
      this.restore_game_log = true;
      await axios
        .post(`/game_logs/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.restore_game_log = false;
          this.is_restored_game_log = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
    formattedDate(date) {
      const dateObj = new Date(date);
      return dateObj.toISOString().slice(0, 10); // Formats the date
    },
  },
};
</script>
